module.exports = __webpack_public_path__ + "img/gif-pad.ebf2fb4b.png";